import Model from '../utils/Model'
import BillType from './BillType'

export class BillReleaseType {
  constructor(code, chineseName, englishName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const CODE_NAME = 'BillReleaseType'
export const CODE_NAME_MBL = 'MBLBillReleaseType'
export const CODE_NAME_HBL = 'HBLBillReleaseType'

// 中文名用于备注，不显示于界面
export const ORIGINAL = new BillType(1, 'ORIGINAL', '正本')
export const SURRENDERED = new BillType(2, 'SURRENDERED', '电放')
export const SEA_WAYBILL = new BillType(3, 'SEA WAYBILL', '电放')

export const HBL_BILL_RELEASE = [ORIGINAL, SURRENDERED]
export const MBL_BILL_RELEASE = [ORIGINAL, SURRENDERED, SEA_WAYBILL]
export const BILL_RELEASES = [
  { serialNumber: 1, code: 'ORIGINAL', name: 'ORIGINAL', localName: '正本' },
  { serialNumber: 2, code: 'SURRENDERED', name: 'SURRENDERED', localName: '电放' },
  { serialNumber: 3, code: 'SEA WAYBILL', name: 'SEA WAYBILL', localName: '电放' }
]

/**
 *  return null:没找到.
 */
export function getBillReleaseTypeByCode(code) {
  return Model.getObjByCode(code, MBL_BILL_RELEASE)
}
